module.exports = __webpack_public_path__ + "63d764a8287d91690943c861e8c910a9.svg";